import { render, staticRenderFns } from "./PartnerPortal.vue?vue&type=template&id=f3bce7da&"
import script from "./PartnerPortal.vue?vue&type=script&lang=js&"
export * from "./PartnerPortal.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPortal.vue?vue&type=style&index=0&id=f3bce7da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
